import {
  TrackingExternalStatusEnum,
  TrackingExternalStatusTypes,
  TrackingStatusEnum,
  TrackingStatusTypes,
} from "@hooks/dtos/ITrackingDTO";

export const TrackingConvertStatus = (
  status: TrackingStatusTypes,
): {
  text: string;
  description: string;
  color: string;
} => {
  switch (status) {
    case TrackingStatusEnum.TRACKING:
      return {
        text: "Em Trânsito",
        description: "O pedido está em andamento.",
        color: "info",
      };

    case TrackingStatusEnum.FINISHED:
      return {
        text: "Entregue",
        description: "O pedido foi entregue com sucesso.",
        color: "success",
      };

    default:
      return {
        text: "Status Desconhecido",
        description: "O status informado não pôde ser identificado.",
        color: "danger",
      };
  }
};

export const TrackingConvertExternalStatus = (
  status: TrackingExternalStatusTypes,
): {
  text: string;
  description: string;
  color: string;
} => {
  switch (status) {
    case TrackingExternalStatusEnum.CREATED:
      return {
        text: "Criado",
        description: "O pedido foi criado.",
        color: "info",
      };

    case TrackingExternalStatusEnum.AGUARDANDO_CONCILIACAO:
      return {
        text: "Conciliação",
        description: "O pedido está aguardando conciliação.",
        color: "warning",
      };

    case TrackingExternalStatusEnum.PENDENCIA_VALIDACAO:
      return {
        text: "Pendência",
        description: "O pedido possui pendência de validação.",
        color: "warning",
      };

    case TrackingExternalStatusEnum.ENTREGUE:
      return {
        text: "Entregue",
        description: "O pedido foi entregue.",
        color: "success",
      };

    case TrackingExternalStatusEnum.CONTIGENCIADO:
      return {
        text: "Contingenciado",
        description: "O pedido está contingenciado.",
        color: "warning",
      };

    default:
      return {
        text: "Status Desconhecido",
        description: "O status informado não pôde ser identificado.",
        color: "danger",
      };
  }
};
